import { Input } from "antd";
import { forwardRef } from "react";
import styled from "styled-components";
import cx from "classnames";
import Button from "../button";
import Tooltip from "../tooltip";
import { useClipboard } from "../../hooks";
import { CopyOutlined, CheckOutlined } from "../../icons";
import { jsx as _jsx } from "react/jsx-runtime";
const StyledInput = styled(Input).withConfig({
  displayName: "copyable__StyledInput",
  componentId: "sc-v8t9t0-0"
})(["& .ant-input[data-disabled=\"false\"]{background:", ";color:", ";}"], p => p.theme.colors.bg.component, p => p.theme.colors.text);
const CopyIcon = styled(CopyOutlined).withConfig({
  displayName: "copyable__CopyIcon",
  componentId: "sc-v8t9t0-1"
})(["color:", ";cursor:pointer;transition:all 0.3s;&:hover,&:focus{color:", ";}.ant-input-affix-wrapper-disabled &{color:", ";cursor:not-allowed;}"], p => p.theme.colors.gray.base, p => p.theme.colors.text, p => p.theme.colors.disabled);
const SuccessIcon = styled(CheckOutlined).withConfig({
  displayName: "copyable__SuccessIcon",
  componentId: "sc-v8t9t0-2"
})(["&,&:hover,&:focus{color:", ";}"], p => p.theme.colors.positive.base);
export const Copyable = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    value,
    size,
    disabled = false,
    className,
    onCopy,
    onFocus,
    ...rest
  } = _ref;
  const {
    copy,
    hasCopied
  } = useClipboard(value);
  const classString = cx("ant-input-search", className);
  const handleCopy = () => {
    if (!hasCopied) {
      copy();
      onCopy?.();
    }
  };
  const copyButton = /*#__PURE__*/_jsx(Button, {
    className: "ant-input-search-button",
    size: size,
    disabled: disabled,
    icon: hasCopied ? /*#__PURE__*/_jsx(SuccessIcon, {}) : /*#__PURE__*/_jsx(CopyIcon, {}),
    onClick: handleCopy
  });
  const addonAfter = disabled ? copyButton : /*#__PURE__*/_jsx(Tooltip, {
    title: hasCopied ? "Copied" : "Copy",
    children: copyButton
  }, "copy");
  return /*#__PURE__*/_jsx(StyledInput, {
    ...rest,
    ref: ref,
    className: classString,
    addonAfter: addonAfter,
    value: value,
    size: size,
    "data-disabled": disabled,
    disabled: true,
    readOnly: true
  });
});
export default Copyable;